import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { toastError, toastSuccess } from '../../../shared/toastHelper';
import {
  holdChallengeErrorMessage,
  startHoldChallenge,
  withdrawHoldChallenge
} from '../api/holdChallengesApi';
import '../styles/holdChallenges.css';

const HoldChallengeRowAction = ({ hold, isTopHold, team, onChallengesChanged }) => {
  const [submitting, setSubmitting] = useState(false);
  const outgoing = (hold.challenges || []).find((challenge) => challenge.role === 'challenger');

  if (!outgoing && isTopHold) return null;

  const run = (request, successMessage, fallbackError) => {
    setSubmitting(true);
    request()
      .then(() => {
        toastSuccess(successMessage);
        onChallengesChanged();
      })
      .catch((error) => toastError(holdChallengeErrorMessage(error, fallbackError)))
      .finally(() => setSubmitting(false));
  };

  if (outgoing) {
    return (
      <button
        type='button'
        disabled={submitting}
        className='hold-reorder-challenge-btn setlist-text-xs'
        title={`Challenging H${outgoing.other_position}. Click to withdraw.`}
        onClick={() => run(
          () => withdrawHoldChallenge(team, outgoing.id),
          'Challenge withdrawn',
          'Could not withdraw the challenge.'
        )}
      >
        <i className={`fas fa-bolt mr-1 ${outgoing.overdue ? 'hold-challenge-overdue' : 'hold-challenge-open'}`}></i>
        Withdraw
      </button>
    );
  }

  return (
    <button
      type='button'
      disabled={submitting}
      className='hold-reorder-challenge-btn setlist-text-xs'
      title='Challenge the first hold on this date'
      onClick={() => run(
        () => startHoldChallenge(team, hold.hold_position_id),
        'Challenge started',
        'Could not start the challenge.'
      )}
    >
      <i className='far fa-bolt mr-1'></i>
      Challenge
    </button>
  );
};

HoldChallengeRowAction.propTypes = {
  hold: PropTypes.shape({
    hold_position_id: PropTypes.number.isRequired,
    challenges: PropTypes.array
  }).isRequired,
  isTopHold: PropTypes.bool.isRequired,
  team: PropTypes.object.isRequired,
  onChallengesChanged: PropTypes.func.isRequired
};

export default HoldChallengeRowAction;
